import { React, useEffect, useState } from 'react';
import { PersonalContainer } from '@atoms/dashboard/personalDashboard.styles';
import { useRecoilValue } from 'recoil';
import {
  Recoil_Quarter_State,
  Current_User,
  System_Date_Time_State,
  Recoil_Selected_Account_State,
} from '@recoil/recoil';
import DataCardOneGcsp from '@molecules/gcsp/components/dashboard/dataCardOneGcsp';
import DataCardTwoGcsp from '@molecules/gcsp/components/dashboard/dataCardTwoGcsp';

import { getMslMyDashboardData } from '@services/mslServices';
import ProfileCard from '@molecules/pursuitLeader/components/dashboard/profileCard';
import { getDashboardProfileDetails, getDashboardAllQuartersData } from '@services/commonServices';

const PersonalDashboardMsl = () => {
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const currentUser = useRecoilValue(Current_User);
  const selectedUser = useRecoilValue(Recoil_Selected_Account_State);
  const systemDateTime = useRecoilValue(System_Date_Time_State);

  const [profileData, setProfileData] = useState(null);
  const [desktopData, setDesktopData] = useState(null);

  const [dashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (quarterInfo !== null) {
        const currentYear = quarterInfo.fiscal_year;

        // Change to MSL
        const myDesktopData = await getMslMyDashboardData(
          quarterInfo.fiscal_year,
          currentUser.account_id,
          currentUser.email,
          systemDateTime.split('T')[0],
        );
        setDesktopData(myDesktopData);

        try {
          // Fetch profile data
          const myProfileDate = await getDashboardProfileDetails(currentUser.email);
          setProfileData(myProfileDate);

          // Fetch all quarters data (single API call for MSL role)
          const allQuartersData = await getDashboardAllQuartersData(
            currentUser.email,
            currentYear,
            systemDateTime.split('T')[0],
            selectedUser.role,
            currentUser.account_id,
          );
          setDashboardData(allQuartersData);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    };

    fetchData();
  }, [quarterInfo]);

  return (
    <>
      {quarterInfo !== null && profileData !== null && dashboardData !== null ? (
        <PersonalContainer>
          <ProfileCard data={profileData} />
          <DataCardOneGcsp data={dashboardData.forecast_accuracy} />
          <DataCardTwoGcsp data={desktopData.forecast_completion} />
        </PersonalContainer>
      ) : null}
    </>
  );
};

export default PersonalDashboardMsl;
